import { LOCALE_ID, Pipe, PipeTransform, inject } from "@angular/core";
import { LgTranslateService } from "@logex/framework/lg-localization";
import { pluralRuleSelect } from "@shared/helpers/pluralRulesIntlHelper";

@Pipe({
    name: "fmtOrdinal",
    standalone: false
})
export class OrdinalSuffix implements PipeTransform {
    protected locale = inject(LOCALE_ID);
    private _lgTranslate = inject(LgTranslateService);

    transform(value: number): string {
        if (!Number.isInteger(value)) throw new Error("Expecting interger value!");
        const rule = pluralRuleSelect(this.locale, value);

        return this._lgTranslate.translate("APP.PluralizationRules.Ordinal", { value, rule });
    }
}
